<template>
  <common-page-layout v-if="business">  
    
    <span slot="fixedtopbuttons">   
        <large-button @click="$router.push('/admin/customerremedials/processing')">Remedials</large-button>     
        <large-button v-if="addtohomescreen" @click="addToHomeScreen()" >Add To Home</large-button>
    </span>
   
    
    <div class="w3-row" slot="smallscreen"> 
        <h5 v-if="addtohomescreen" >        
          <font color="green">Click add to Home to create a short cut on your home screen. This provides a nicer experience like a normal mobile or PC app without installing anything at all.</font>
        </h5>  

        <business-image-basic-tile :business="business"/>
    </div>

    <div class="w3-row" slot="largescreen">     

      <div class="w3-quarter w3-container">
          <!-- <my-remedials-tile /><br>    -->
          <options-tile />
      </div>

      <div class="w3-half w3-container">
        <business-image-basic-tile class="w3-card-4" :business="business"/><br>
         <home-about-tile :business="business" />
      </div>

      <div class="w3-quarter w3-container">
          <customer-remedials-tile :adminrights="adminrights"/><br>      
      </div>

  </div>

    


    
    
    
  </common-page-layout>
</template>

<script>
import AdminCustomersRemedialsHome from '@/components/admin/customerremedials/AdminCustomersRemedialsHome'
import CustomerRemedialsTile from '@/components/home/CustomerRemedialsTile'
import BusinessImageBasicTile from '@/components/home/BusinessImageBasicTile'
import HomeAboutTile from '@/components/home/HomeAboutTile'
import MyRemedialsTile from '@/components/home/MyRemedialsTile'
import OptionsTile from '@/components/home/OptionsTile'

  import {
    mapGetters,
    mapActions
  } from "vuex";
  export default {
    name: "Home",
    methods:{
      ...mapActions(['addToHomeScreen'])
    },
    computed: mapGetters(["business","addtohomescreen","adminrights","sysadmin"]),
    components:{
      'remedials-home':AdminCustomersRemedialsHome,
      'customer-remedials-tile':CustomerRemedialsTile,
      'home-about-tile':HomeAboutTile,
      'business-image-basic-tile':BusinessImageBasicTile,
      'my-remedials-tile':MyRemedialsTile,
      'options-tile':OptionsTile
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/Home.vue